import { createReducer } from "reduxsauce";

import Actions from "modules/user/user-actions";

const INITIAL_STATE = {
  consent: false
};

const storeUser = (state, { user }) => user;
const setConsent = (state = INITIAL_STATE, { consent }) => ({
  ...state,
  consent
});

export const HANDLERS = {
  [Actions.Types.USER_FETCHED]: storeUser,
  [Actions.Types.SET_CONSENT]: setConsent
};

export default createReducer(INITIAL_STATE, HANDLERS);



// WEBPACK FOOTER //
// ./src/modules/user/user-reducer.js